import { getImageCdnForUrl } from "./detect.js";
import { transform as contentful } from "./transformers/contentful.js";
import { transform as builderio } from "./transformers/builder.io.js";
import { transform as imgix } from "./transformers/imgix.js";
import { transform as shopify } from "./transformers/shopify.js";
import { transform as wordpress } from "./transformers/wordpress.js";
import { transform as cloudimage } from "./transformers/cloudimage.js";
import { transform as cloudinary } from "./transformers/cloudinary.js";
import { transform as cloudflare } from "./transformers/cloudflare.js";
import { transform as bunny } from "./transformers/bunny.js";
import { transform as storyblok } from "./transformers/storyblok.js";
import { transform as kontentai } from "./transformers/kontent.ai.js";
import { transform as vercel } from "./transformers/vercel.js";
import { transform as nextjs } from "./transformers/nextjs.js";
import { transform as scene7 } from "./transformers/scene7.js";
import { transform as keycdn } from "./transformers/keycdn.js";
import { transform as directus } from "./transformers/directus.js";
import { transform as imageengine } from "./transformers/imageengine.js";
import { transform as contentstack } from "./transformers/contentstack.js";
import { transform as cloudflareImages } from "./transformers/cloudflare_images.js";
import { transform as ipx } from "./transformers/ipx.js";
import { transform as astro } from "./transformers/astro.js";
import { transform as netlify } from "./transformers/netlify.js";
import { transform as imagekit } from "./transformers/imagekit.js";
import { transform as uploadcare } from "./transformers/uploadcare.js";
import { transform as supabase } from "./transformers/supabase.js";
import { transform as hygraph } from "./transformers/hygraph.js";
import { getCanonicalCdnForUrl } from "./canonical.js";
export const getTransformer = cdn => ({
  imgix,
  contentful,
  "builder.io": builderio,
  shopify,
  wordpress,
  cloudimage,
  cloudinary,
  bunny,
  storyblok,
  cloudflare,
  vercel,
  nextjs,
  scene7,
  "kontent.ai": kontentai,
  keycdn,
  directus,
  imageengine,
  contentstack,
  "cloudflare_images": cloudflareImages,
  ipx,
  astro,
  netlify,
  imagekit,
  uploadcare,
  supabase,
  hygraph
})[cdn];
/**
 * Returns a transformer function if the given CDN is supported
 */
export const getTransformerForCdn = cdn => {
  if (!cdn) {
    return undefined;
  }
  return getTransformer(cdn);
};
/**
 * Transforms an image URL to a new URL with the given options.
 * If the URL is not from a known image CDN it returns undefined.
 */
export const transformUrl = options => {
  var _options$cdn, _options$recursive, _getTransformer;
  const cdn = (_options$cdn = options === null || options === void 0 ? void 0 : options.cdn) !== null && _options$cdn !== void 0 ? _options$cdn : getImageCdnForUrl(options.url);
  // Default to recursive
  if (!((_options$recursive = options.recursive) !== null && _options$recursive !== void 0 ? _options$recursive : true)) {
    var _getTransformerForCdn;
    return (_getTransformerForCdn = getTransformerForCdn(cdn)) === null || _getTransformerForCdn === void 0 ? void 0 : _getTransformerForCdn(options);
  }
  const canonical = getCanonicalCdnForUrl(options.url, cdn);
  if (!canonical || !canonical.cdn) {
    return undefined;
  }
  return (_getTransformer = getTransformer(canonical.cdn)) === null || _getTransformer === void 0 ? void 0 : _getTransformer(Object.assign({}, options, {
    url: canonical.url
  }));
};
/**
 * Returns a transformer function if the given URL is from a known image CDN
 *
 * @deprecated Use `getCanonicalCdnForUrl` and `getTransformerForCdn` instead
 */
export const getTransformerForUrl = url => getTransformerForCdn(getImageCdnForUrl(url));